import { takeLatest, put, call } from 'redux-saga/effects'
import apiCall from '../helpers/apiCall'
import {
  CREATE_LESSON_PLAN,
  CREATE_LESSON_PLAN_FAIL,
  CREATE_LESSON_PLAN_SUCCESS,
  CreateLessonPlanActionType
} from '../redux/lessonPlansReducer'
import { LessonPlan } from '../types'

function* CreateLessonFlow(action: CreateLessonPlanActionType): Generator<any, void, any> {
  try {
    const params = { lesson_plan: action.payload }
    const response: LessonPlan = yield call(apiCall, {
      endpoint: `/tutors/units/${action.payload.unitId}/lesson_plans`,
      method: 'POST',
      params
    })
    yield put(CREATE_LESSON_PLAN_SUCCESS({ unitId: action.payload.unitId, lessonPlan: response }))
  } catch (error) {
    yield put(CREATE_LESSON_PLAN_FAIL())
    console.log(error)
  }
}

export default function* CreateLessonPlan(): Generator<any, void, any> {
  yield takeLatest([CREATE_LESSON_PLAN], CreateLessonFlow)
}
